import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { TEXTURE_IMG, LOGO_URL } from "@/data/content";
import { openCookieSettings } from "@/lib/consent";

export default function Footer() {
  return (
    <footer
      className="relative bg-[#0A0A0B] text-[#F7F5F0]"
      style={{ backgroundImage: `linear-gradient(to bottom, rgba(10,10,11,0.92), rgba(10,10,11,0.98)), url(${TEXTURE_IMG})`, backgroundSize: "cover" }}
      data-testid="footer"
    >
      <div className="px-5 md:px-12 lg:px-24 py-8 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-x-8 gap-y-8 md:gap-12 pb-8 md:pb-16 border-b border-white/10">
          {/* Logo: hidden on mobile (rendered below), visible at top on desktop */}
          <div className="hidden md:block md:col-span-4">
            <img
              src={LOGO_URL}
              alt="TheCityPair"
              data-testid="footer-logo"
              className="h-28 w-auto object-contain -ml-2 mb-4"
            />
            <p className="text-[#A09E9A] text-sm leading-relaxed max-w-xs">
              Premium flight reservations curated for travelers who value time, comfort, and a story worth telling.
            </p>
          </div>

          {/* Explore: half-row on mobile (col-span-1), 2/12 on desktop */}
          <div className="md:col-span-2">
            <p className="tcp-overline text-[#C29B62] mb-3 md:mb-4">Explore</p>
            <ul className="space-y-2.5 md:space-y-3 text-sm text-[#A09E9A]">
              <li><Link to="/" className="hover:text-[#C29B62]" data-testid="footer-home">Home</Link></li>
              <li><Link to="/search" className="hover:text-[#C29B62]" data-testid="footer-search">Search</Link></li>
              <li><Link to="/destinations" className="hover:text-[#C29B62]" data-testid="footer-destinations">Destinations</Link></li>
              <li><Link to="/journal" className="hover:text-[#C29B62]" data-testid="footer-journal">Journal</Link></li>
              <li><Link to="/contact" className="hover:text-[#C29B62]" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Legal: half-row on mobile (sits next to Explore), 2/12 on desktop */}
          <div className="md:col-span-2">
            <p className="tcp-overline text-[#C29B62] mb-3 md:mb-4">Legal</p>
            <ul className="space-y-2.5 md:space-y-3 text-sm text-[#A09E9A]">
              <li><Link to="/privacy" className="hover:text-[#C29B62]" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#C29B62]" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/cookies" className="hover:text-[#C29B62]" data-testid="footer-cookies">Cookie Policy</Link></li>
              <li><Link to="/data-protection" className="hover:text-[#C29B62]" data-testid="footer-dp">Data Protection</Link></li>
              <li>
                <button
                  type="button"
                  onClick={openCookieSettings}
                  data-testid="footer-cookie-prefs"
                  className="hover:text-[#C29B62] text-left"
                >
                  Cookie Preferences
                </button>
              </li>
            </ul>
          </div>

          {/* Contact: full row on mobile, 4/12 on desktop */}
          <div className="col-span-2 md:col-span-4">
            <p className="tcp-overline text-[#C29B62] mb-3 md:mb-4">Contact</p>
            <ul className="space-y-2.5 md:space-y-3 text-sm text-[#A09E9A]">
              <li className="flex items-start gap-3"><Phone size={18} className="mt-0.5 text-[#C29B62] shrink-0" /><span>+1 (888) 555-7873 · Mon–Sun, 24/7</span></li>
              <li className="flex items-start gap-3"><EnvelopeSimple size={18} className="mt-0.5 text-[#C29B62] shrink-0" /><span>concierge@thecitypair.com</span></li>
              <li className="flex items-start gap-3"><MapPin size={18} className="mt-0.5 text-[#C29B62] shrink-0" /><span>1736 Holly Oak Ln<br/>Chattanooga, TN 37421, USA</span></li>
            </ul>
          </div>

          {/* Logo at the BOTTOM on mobile, with tagline */}
          <div className="md:hidden col-span-2 pt-4 border-t border-white/10 flex flex-col items-center text-center">
            <img
              src={LOGO_URL}
              alt="TheCityPair"
              data-testid="footer-logo-mobile"
              className="h-20 w-auto object-contain mb-3"
            />
            <p className="text-[#A09E9A] text-xs leading-relaxed max-w-xs">
              Premium flight reservations curated for travelers who value time, comfort, and a story worth telling.
            </p>
          </div>
        </div>

        <div className="pt-5 md:pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 md:gap-4">
          <p className="text-[11px] md:text-xs text-[#A09E9A] text-center md:text-left w-full md:w-auto">© {new Date().getFullYear()} TheCityPair LLC. All rights reserved. A US-based travel arranger.</p>
        </div>
      </div>
    </footer>
  );
}
